import { render, staticRenderFns } from "./PermissionCreateView.vue?vue&type=template&id=433a9e24&scoped=true&"
import script from "./PermissionCreateView.vue?vue&type=script&lang=js&"
export * from "./PermissionCreateView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433a9e24",
  null
  
)

export default component.exports